import { async } from "@firebase/util";
import { getDatabase, ref, child, get, update} from "firebase/database";
import { IpAddresses } from "../Constants/constants";

export const acceptInvitationGuestInvite = async (input) => {
  console.log("input",input);
    const dbRef = ref(getDatabase());
    let invObj = {}
    invObj[input['uid']] = {
        status: input.status,
        displayName: input.displayName,
        username: input.username,
        profilePic: input.profilePic,
    }
    const updateUser = await update(child(dbRef, `Events/${input['uid']}/${input.id}/data/`), input.post)
    console.log(invObj)    
    const resp = await update(child(dbRef, `Waitlist/${input.author}/${input.id}`), invObj)
    return (resp)
}

export const getWaitList = async(author, id, uid) => {
    const dbRef = ref(getDatabase());
    const posts = await get(child(dbRef, `Waitlist/${author}/${id}/${uid}`)).then((snapshot) => {
        if (snapshot.exists()) {
          return snapshot.val();
        } else {
            console.log("No data available");
            return(undefined)          
        }
      }).catch((error) => {        
        console.error(error);
        return(undefined)          
      });
    return(posts)   
}

